import React from 'react';

import styles from './LoadingSpinner.module.scss';

export default () => (
  <div className="d-flex flex-column align-self-center justify-content-center align-items-center flex-grow-1">
    <div className={styles.spinner} />
  </div>
);
